// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"cc3c9d52","996":"902d5d4d"}[chunkId] + ".chunk.js";
};